export { default as CourseChapter } from './CourseChapter';
